
import { Component, Mixins, Watch } from "vue-property-decorator";
import { DialogMixin } from "../../mixins";

@Component({
})
export default class SelectorDialogMixin extends Mixins(DialogMixin) {
  data(): any {
    return {
      selected: undefined,
      isSelecting: false,
    };
  }
  selected: any;
  isSelecting: boolean;

  validate: (selected?: any) => Promise<boolean>;

  get hasSelected(): boolean {
    return (Array.isArray(this.selected) ? this.selected.length > 0 : !!this.selected)
      && this.isSelecting;
  }

  @Watch("isVisible")
  onIsSingleSelectorDialogVisibleChanged(newValue: boolean, oldValue: boolean) {
    if (!newValue && this.isSelecting) {  // まだ選択中なのに非表示になった場合はキャンセル.
      this.selected = undefined;  // キャンセル.
      this.isSelecting = false;
    }
  }

  @Watch("isSelecting")
  onIsSingleSelectorDialogSelectingChanged(newValue: boolean, oldValue: boolean) {
    this.isVisible = newValue;
  }

  async show<T>(defaultOption: T): Promise<T> {
    return this.showModal(async () => {
      this.selected = defaultOption;
      this.isSelecting = true;
      await this.waitHidden();
      return this.selected;
    });
  }

  select(selected?: any): void {
    if (!!this.validate) {
      this.validate(selected ? selected : this.selected)
      .then(isOk => {
        if (!isOk) { return; }
        this.selectAndClose(selected);
      });
    } else {
      this.selectAndClose(selected);
    }
  }

  selectAndClose(selected?: any): void {
    if (selected) {
      this.selected = selected;
    }
    this.isSelecting = false;
  }

  clear(): void {
    this.selected = null;
    this.isSelecting = false;
  }

  cancel(): void {
    this.selected = undefined;
    this.isSelecting = false;
  }
}
